import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NewCustomerPage } from './new-customer.page';
import { NewCustomerFormComponent } from './new-customer-form.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    ReactiveFormsModule,
  ],
  declarations: [
    NewCustomerPage,
    NewCustomerFormComponent,
  ],
  providers: [],
  exports: [
    NewCustomerPage,
  ]
})
export class CustomersModule {
}
